export enum OrbitAddProjectStep {
  FORM,
  REVIEW_FORM,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  ADDED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
  TOKEN_NOT_WHITELISTED,
}
